import {EnumTypVysledek, SearchResultVO} from '../../api';

/** Položka výřezového seznamu – objekt z aktuálního výřezu mapy (bohaté vykreslení). */
export type ViewportResult = {
    /** Composite klíč `layerId:featureId` – identifikátor řádku pro VirtualList (unikátní napříč vrstvami). */
    id: string;
    featureId: string;
    layerId: number;
    label: string;
    /** Podtitulek pod názvem – „adresa, město" z hodnot objektu (nahrazuje zobrazení názvu vrstvy). */
    subtitle?: string;
    layerLabel?: string;
    layerImageUrl?: string;
    photoUrl?: string;
    accessibilityCodes: string[];
    /** Barva vrstvy (CSS) – pruh v hlavičce položky, pokud je na vrstvě nastavena. */
    layerColor?: string;
};

/** Převede RGB pole vrstvy ([r,g,b]) na CSS barvu; vrátí undefined, pokud barva není. */
export const layerColorToCss = (color?: number[]): string | undefined => {
    if (!color || color.length < 3) return undefined;
    const [r, g, b] = color;
    return `rgb(${r}, ${g}, ${b})`;
};

/** Položka seznamu výsledků fulltextového hledání (jako v Search.tsx). */
export type SearchListItem = SearchResultVO & {
    title?: string;
    typVysledek?: EnumTypVysledek;
    /** Upřesnění lokačního výsledku ze skupiny vrácené konektorem (Adresa, Ulice, Parcela…). */
    resultTypeLabel?: string;
    statusRow?: boolean;
    count?: number;
};

/** Popis počtu nalezených objektů se správným skloňováním (shodné se Search.tsx). */
export const getFoundCountLabel = (count: number): string => {
    if (count === 1) return 'Nalezen 1 objekt';
    if (count >= 2 && count <= 4) return `Nalezeny ${count} objekty`;
    return `Nalezeno ${count} objektů`;
};
